import React from 'react';
import Tooltip from '../popups/Tooltip';
import "./TableActionIcon.scss";

const TableActionIcon = (props) => {
	const { icon, toolTip, onClick, disabled, className, colour, hover, children, noMargin, id } = props;

	return (
		<div id={id} className={`table-action-icon-wrapper${disabled ? " table-action-icon-disabled" : ""}${className ? " " + className : ""}`} onClick={onClick} style={{marginRight: noMargin ? 0 : ""}}>
			{toolTip ? (
				<Tooltip label={toolTip} offsetY={15}>
					<div className={`table-action-icon${colour ? " table-action-icon-" + colour : ""}${hover ? " hover-" + hover : ""}`}>{icon || children}</div>
				</Tooltip>
			) : (
				<div className={`table-action-icon${colour ? " table-action-icon-" + colour : ""}${hover ? " hover-" + hover : ""}`}>{icon || children}</div>
			)}
		</div>
	);
}

export default TableActionIcon;